module.exports = __webpack_public_path__ + "img/ISOOC.a2d77a31.png";